import { Sun, Moon, Monitor } from "lucide-react";
import { useThemeStore } from "../../stores/themeStore";

const themes = [
  { value: "light" as const, icon: Sun, label: "Light" },
  { value: "dark" as const, icon: Moon, label: "Dark" },
  { value: "system" as const, icon: Monitor, label: "System" },
];

export function ThemeToggle() {
  const { theme, setTheme } = useThemeStore();

  // Cycle through themes on click
  const cycle = () => {
    const order = ["light", "dark", "system"] as const;
    const idx = order.indexOf(theme);
    setTheme(order[(idx + 1) % order.length]);
  };

  const current = themes.find((t) => t.value === theme) || themes[0];
  const Icon = current.icon;

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={`Theme: ${current.label}. Change theme`}
      className="flex h-10 w-10 items-center justify-center rounded-xl text-gray-400 transition-colors hover:bg-teal-50 hover:text-teal-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal-500"
      title={`Theme: ${current.label}`}
    >
      <Icon className="w-5 h-5" />
    </button>
  );
}
